<template>
  <div class="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center justify-center px-4 py-16 text-center">
    <img class="w-64" src="https://storage.hypefactors.com/images/branding/hf_logo_full_dark.png" alt="">

    <h2 class="mt-10 font-display text-3xl font-bold text-ink md:text-4xl">
      We're down for maintenance
    </h2>

    <div v-if="message" class="mt-6 text-lg leading-relaxed text-muted" v-html="message" />
    <div v-else class="mt-6 text-lg leading-relaxed text-muted">
      We'll be back shortly.
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      message: 'getMaintenanceModeMessage'
    })
  }
}
</script>
